import gsap from "gsap"

class BannerWordTicker {
  constructor(el) {

    this.index = 0
    this.timer = 4000
    this.ticker = el.querySelectorAll('.banner__word-ticker')
    this.words = el.querySelectorAll('.banner__word-ticker span')
    this.currentIndex = 0
    
    this.words.forEach((word, i) => {
      if (i !== 0) {
        gsap.set(word, { y: '150%' })
      }
    })
    
    setTimeout(() => { this.changeWord() }, this.timer)

  }
  changeWord() {
    const nextIndex = (this.currentIndex + 1) % this.words.length
    const exitingIndex = this.currentIndex 
    
    gsap.to(this.words[this.currentIndex], {
      duration: 0.75, 
      y: '-150%', 
      ease: 'power2.inOut',
      onComplete: () => {
        gsap.set(this.words[exitingIndex], { y: '150%' })
      }
    })
    
    gsap.to(this.words[nextIndex], {duration: 0.75, y: '0', ease: 'power2.inOut' })
    gsap.to(this.ticker, { duration: 0.5, delay: 0.1, width: this.words[nextIndex].offsetWidth + 'px', ease: 'power2.inOut'})
    
    this.currentIndex = nextIndex
    
    setTimeout(() => { this.changeWord() }, this.timer)
  }
}

export const initBannerWordTicker = () => {

  const section = document.querySelector('.banner')

	if (section) new BannerWordTicker(section)

}

export default () => {}
